import React, { createContext, useContext, useState } from 'react';

import { LoginId } from 'client-core';

type OpenLogin =
  | {
      id: LoginId;
      dirty: boolean;
      save: () => Promise<void>;
    }
  | undefined;

type LoginEditContextValue = {
  openLogin: OpenLogin;
  setOpenLogin: (l: OpenLogin) => void;
};

const LoginEditContext = createContext<LoginEditContextValue>({
  openLogin: undefined,
  setOpenLogin: () => undefined,
});

export function LoginEditContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [openLogin, setOpenLogin] = useState<OpenLogin>(undefined);
  return (
    <LoginEditContext.Provider value={{ openLogin, setOpenLogin }}>
      {children}
    </LoginEditContext.Provider>
  );
}

export function useLoginEditContext() {
  return useContext(LoginEditContext);
}

export function useOpenLogin() {
  const { openLogin } = useLoginEditContext();
  return openLogin;
}
